<template>
  <form-basic-point-settings :submit="submit" role="create"></form-basic-point-settings>
</template>
<script>
import { mapActions } from "vuex";
import { Loading, MessageBox } from "element-ui";
import FormBasicPointSettings from "./FormBasicPointSettings";
import { userRolesCheck } from "@/util/userRoles";
import Swal from "sweetalert2";

export default {
  components: {
    "form-basic-point-settings": FormBasicPointSettings,
  },
  created() {
    userRolesCheck("create", "point_earning_rules");
  },
  methods: {
    ...mapActions("basicPoint", ["saveBasicPoint"]),
    submit() {
      let loadingInstance = Loading.service({
        fullscreen: true,
      });
      this.saveBasicPoint()
        .then((response) => {
          loadingInstance.close();
          Swal.fire({
            icon: "success",
            title: "Create basic point success",
            text: "Create saved",
            onClose: () => {
              this.$router.push({ name: "PointEarningRules" });
            }
          });
        })
        .catch((error) => {
          loadingInstance.close();
          this.$notify({
            message: "Create basic point failed",
            timeout: 5000,
            icon: "now-ui-icons ui-1_bell-53",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    }
  }
};
</script>
<style scoped>
</style>
